import { PositionSetRepository } from '@view-model/models/common/PositionSet/infrastructure/PositionSetRepository';
import { FileContainer } from './FileContainer';
import { FileContainerCollection } from './FileContainerCollection';
import { FileContainerCollectionContents } from './FileContainerCollectionContents';
import type { FileContainerJSON, ModelId, ViewModelId } from 'balus-common';
import { RecordRepository } from '@framework/repository';
import { RTDBPath } from 'balus-common';

export class FileContainerCascadeRepository {
  private readonly containersRepository: RecordRepository<FileContainerJSON, FileContainer>;
  private readonly positionsRepository: PositionSetRepository;

  constructor(viewModelId: ViewModelId, modelId: ModelId) {
    this.containersRepository = new RecordRepository(
      FileContainer,
      RTDBPath.FileContainer.containersPath(viewModelId, modelId)
    );
    this.positionsRepository = new PositionSetRepository(RTDBPath.FileContainer.positionsPath(viewModelId, modelId));
  }

  async saveContents(contents: FileContainerCollectionContents): Promise<void> {
    const { containers, positions } = contents;
    await Promise.all([
      this.containersRepository.save(containers.toRecord()),
      this.positionsRepository.saveAll(positions),
    ]);
  }

  async loadContents(): Promise<FileContainerCollectionContents> {
    const [containers, positions] = await Promise.all([
      this.containersRepository.get(),
      this.positionsRepository.loadAll(),
    ]);

    if (!containers || !positions) return FileContainerCollectionContents.buildEmpty();

    return new FileContainerCollectionContents(new FileContainerCollection(Object.values(containers)), positions);
  }
}
